import * as React from "react"

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }
    mql.addEventListener("change", onChange)
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return !!isMobile
}

// useMinWidth reports whether the viewport is at least the given width, for
// layouts that must switch component trees rather than CSS (e.g. resizable
// panel groups whose panels cannot simply be display-hidden).
export function useMinWidth(px: number) {
  // Initialized synchronously so the first paint already mounts the right
  // tree; starting false and correcting in an effect would remount the wide
  // layout's children (dropping live streams) on every desktop page load.
  const [wide, setWide] = React.useState(
    () => window.matchMedia(`(min-width: ${px}px)`).matches
  )

  React.useEffect(() => {
    const mql = window.matchMedia(`(min-width: ${px}px)`)
    const onChange = () => setWide(mql.matches)
    mql.addEventListener("change", onChange)
    setWide(mql.matches)
    return () => mql.removeEventListener("change", onChange)
  }, [px])

  return wide
}
